export const globalConstants = {
    // getPolicyDetailURL: '/paymentcenterpolicyretrieval/getpolicy?key=Category&value={category}&search={reference}&Zipcode={zip}',
    // validateRoutingURL: 'preprod?RoutingNumber={routingNo}&culture=en-US',
    // updatePaymentDetailURL: '/paymentdetailupdateservice/post',
    // downloadrcptURL: '/downloadreceipt/get?primaryid={id}',
    // emailrcptURL: '/emailreceipt/get?primaryid={id}&emailid={emailId}',
    // apmLogURL: '/logstoapm/add',
    // imageLinkURL: '/dynamodbreadall/dynamodbreadall/read?tableName=paymentcenter-uiparams-dev',
    // OneIncSessionURL: 'https://testportalone.processonepayments.com/api/api/Session/Create?portalOneAuthenticationKey=1ACA3AD7-8426-4A7A-88FF-2ADE4B2BC290',

    // Document Categories
    documentCategories: {
        DECLARATIONS: 'Declarations',
        INVOICES: 'Invoices',
        DECLARATION_PAGE: 'Declaration Page',
        ENDORSEMENTS: 'Endorsements',
        MORTGAGEE_COPY: 'Mortgagee Copy',
        RENEWAL: 'Renewals',
        EVIDENCE_OF_INSURANCE: 'Evidence of Insurance',
        NON_RENEWAL: 'Non-Renewal',
        ID_CARDS: 'ID Cards',
        INSPECTION: 'Inspection',
        DIC_MORTGAGEE_NOTICE: 'DIC Mortgagee Notice',
    },
    intentToControl: {
        Coverage: 'coverage',
        Quote: 'quote',
        'Application submittal': 'applicationSubmittal',
        'Point of sale - Tech support': 'pointOfSaleTechSupport',
        Renewal: 'renewal',
        'Non-Renewal': 'nonRenewal',
        'Conditional Renewal': 'conditionalRenewal',
        Notices: 'notices',
        'Endorsement Request': 'endorsement',
        'Submittals Acknowledgement': 'Submittals Acknowledgement',
        Payments: 'Payments',
        'Bill pay (Guest pay)': 'Bill pay (Guest pay)',
        'Payment plan': 'Payment plan',
        Invoices: 'Invoices',
        'Paper Invoice': 'Paper Invoice',
        CC: 'CC',
        EFT: 'EFT',
        PCN: 'PCN',
        'Cancellation Requests': 'Cancellation Requests',
        'Refund Check': 'Refund Check',
        'Unclaimed Property Checks': 'Unclaimed Property Checks',
        'CVG and/or POI': 'CVG and/or POI',
        'Mortgage and/or Escrow Updates': 'Mortgage and/or Escrow Updates',
        'Binding Suspension (NB)': 'Binding Suspension',
        'CAT Related': 'CAT Related',
        'Producer Access Support': 'Producer Access Support',
        'Jira Ticket': 'JIRA',
        'Claims report': 'Claims Report',
        'Commission check': 'Commission Check',
        'State of Emergency (60 Grace Period)': 'State of Emergency',
    } as Record<string, string>,
};
